export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-960-482ea2b5836fcdcf8542c9fbe11a8808.png";